<router-outlet></router-outlet>
<ng-http-loader [entryComponent]="logoLoader"></ng-http-loader>
